import * as React from 'react';
import { ThemeProvider } from 'styled-components';
import { theme } from './styles';
import { AppRouter } from './Router';
import { AppContextProvider } from './contexts/app/AppContextProvider';
import { OriginThemeProvider } from '@origin-digital/ods-core';
import { MarkdownLinkHandler } from './components/MarkdownLinkHandler/MarkdownLinkHandler';

const App: React.FC = () => {
  return (
    // @ts-ignore
    <OriginThemeProvider linkComponent={MarkdownLinkHandler}>
      <ThemeProvider theme={theme}>
        <AppContextProvider>
          <AppRouter />
        </AppContextProvider>
      </ThemeProvider>
    </OriginThemeProvider>
  );
};

export { App };
